import axiosInstance from "./axiosConfig";

export const subscriptionAPI = {
  // Subscription Types
  createSubscriptionType: (data) =>
    axiosInstance.post("/api/subscription-types/create/", data),
  getSubscriptionTypes: () => axiosInstance.get("/api/subscription-types/"),
  getSubscriptionTypeById: (id) =>
    axiosInstance.get(`/api/subscription-types/${id}/`),
  updateSubscriptionType: (id, data) =>
    axiosInstance.put(`/api/subscription-types/${id}/update/`, data),
  deleteSubscriptionType: (id) =>
    axiosInstance.delete(`/api/subscription-types/${id}/delete/`),

  // Subscription Periods
  createSubscriptionPeriod: (data) =>
    axiosInstance.post("/api/subscription-periods/create/", data),
  getSubscriptionPeriods: () => axiosInstance.get("/api/subscription-periods/"),
  getSubscriptionPeriodById: (id) =>
    axiosInstance.get(`/api/subscription-periods/${id}/`),
  updateSubscriptionPeriod: (id, data) =>
    axiosInstance.put(`/api/subscription-periods/${id}/update/`, data),
  deleteSubscriptionPeriod: (id) =>
    axiosInstance.delete(`/api/subscription-periods/${id}/delete/`),

  // Pending Payments
  getPendingPayments: () => axiosInstance.get("/api/payments/pending/"),
  updatePaymentStatus: (id, data) =>
    axiosInstance.put(`/api/payments/${id}/update-status/`, data),
};
